import { http } from '~/src/services/requests';

export interface ContentFilterOptionsResponse {
  practice_areas: string[];
  jurisdictions: string[];
}

function contentPublishingService() {
  return {
    getContentFilterOptions:
      async (): Promise<ContentFilterOptionsResponse> => {
        const parse = true;
        return http.innerSendAuthenticated(
          {
            relativePath: '/api/v3/content_publishing/filter-options',
            method: 'GET',
          },
          parse,
        );
      },
  };
}

export default contentPublishingService();
